<template>
  <div class="flex flex-wrap">
    <div class="w-full lg:w-12/12 px-4">
      <Form pageType="Add" :onSubmit="onSubmit" :alertType="this.alertType" :alertMessage="this.alertMessage"
        :clientProps="client" />
    </div>
  </div>
</template>
<script>
import { UseAppStore } from '@/stores/AppStore';
import Form from "@/views/admin/pricings/Form.vue";
import PricingDataService from "@/services/PricingDataService";

export default {
  setup() {
    const appStore = UseAppStore();
    appStore.resetBreadcrumbs();
    appStore.putBreadcrumbs("dashboard", "Dashboard", "/admin/dashboard")
    appStore.putBreadcrumbs("pricings", "Pricing", "/admin/pricings")
    return {
      appStore
    }
  },
  data() {
    return {
      alertType: '',
      alertMessage: '',
      client: {}
    }
  },
  components: {
    Form
  },
  methods: {
    redirectBack() {
      this.$router.replace('/admin/pricings')
    },
    onSubmit(data) {
      console.log(data)
      PricingDataService.create(data)
        .then(() => {
          this.alertType = 'Success'
          this.alertMessage = 'Pricing successfuly created'

          this.countDownTimer(3, this.redirectBack)
        })
        .catch(e => {
          this.alertType = 'Failed'
          this.alertMessage = e.response.data.code_message
          this.countDownTimer(3)
          console.log(e);
        });
    },
    countDownTimer(countDown, callback) {
      if (countDown > 0) {
        setTimeout(() => {
          countDown -= 1
          this.countDownTimer(countDown, callback)
        }, 1000)
      } else {
        this.alertType = ''
        if (callback != undefined) {
          callback()
        }
      }
    }
  }
};
</script>
